import React, { useEffect, useRef, useState } from "react"
import Card from "@mui/material/Card"
import SkeletonCard from "../../core/SkeletonCard/SkeletonCard"
import TextField from "@mui/material/TextField"
import Axios from "../../../Util/Axios"
import { useNavigate } from "react-router-dom"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { TOAST_SEVERITY_ERROR } from "../../core/Toast/Toast"
import List from "@mui/material/List"
import { updateToastData } from "../../../slices/toastSlice"
import { useDispatch } from "react-redux"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import SendIcon from "@mui/icons-material/Send"
import IconButton from "@mui/material/IconButton"

const OrderMessages = ({ orderData, setOrderData, isStaff, senderEmail }) => {
  const [newMessage, setNewMessage] = useState("")

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const messagesEndRef = useRef(null)
  const messages = orderData?.messages

  useEffect(() => {
    if (messagesEndRef?.current) {
      setTimeout(() => {
        // messagesEndRef.current?.scrollIntoView({
        //   behavior: "instant",
        //   block: "center",
        // })
        messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight
      }, 100)
    }
  }, [messages])

  if (!orderData) {
    return <SkeletonCard />
  }
  if (orderData.type !== "custom") {
    return <React.Fragment />
  }

  const sendMessage = () => {
    if (!newMessage) {
      dispatch(
        updateToastData({
          message: "Message cannot be empty",
          severity: TOAST_SEVERITY_ERROR,
        })
      )

      return
    }
    let url = `/api/order-detail/${orderData.customer_facing_id}/action_send_message/`
    if (isStaff) {
      url = `/api/staff-order-detail/${orderData.customer_facing_id}/action_send_message/`
    }
    setLoading(true)
    Axios.post(
      url,
      {
        text: newMessage,
        sender_email: senderEmail,
      },
      navigate
    )
      .then(({ data }) => {
        orderData.messages = data.messages
        setLoading(false)
        setNewMessage("")
      })
      .catch((e) => {
        setLoading(false)
        dispatch(
          updateToastData({
            message: "Error Sending Message",
            severity: TOAST_SEVERITY_ERROR,
          })
        )
      })
  }

  return (
    <Grid item>
      <Card sx={{ height: "600px", display: "flex", flexDirection: "column" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={3}
          px={2}
        >
          <Typography
            variant="h6"
            fontWeight="medium"
            textTransform="capitalize"
          >
            Messages
          </Typography>
        </Box>
        <Box pt={3} pb={2} px={2} sx={{ overflow: "auto", flex: "1" }}>
          <Box
            component="ul"
            display="flex"
            flexDirection="column"
            p={0}
            m={0}
            sx={{ listStyle: "none" }}
            ref={messagesEndRef}
          >
            <List>
              {messages.map((message, i) => {
                let alignRight =
                  (isStaff && message.staff_member) ||
                  (!isStaff && !message.staff_member)
                return (
                  <Box
                    key={i}
                    component="li"
                    display="flex"
                    flexDirection="column"
                    justifyContent={alignRight ? "flex-end" : "flex-start"}
                    alignItems={alignRight ? "flex-end" : "flex-start"}
                    py={1}
                    pr={1}
                    mb={0}
                    // ref={i === messages.length - 1 ? messagesEndRef : null}
                  >
                    <Box pl={0.5} pb={0.5}>
                      <Typography
                        display="block"
                        variant="text"
                        fontWeight="bold"
                        color="dark"
                        style={{
                          fontFamily: "Josefin Sans",
                        }}
                      >
                        {message.sender_email}
                      </Typography>
                    </Box>
                    <Box lineHeight={1} sx={{ maxWidth: "70%" }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems={alignRight ? "flex-end" : "flex-start"}
                        px={2}
                        py={1}
                        borderRadius={"2"}
                        bgcolor={alignRight ? "primary.light" : "grey.200"}
                        sx={{
                          backgroundColor: alignRight ? "#147efb" : "#8e8e93",
                          borderRadius: 4,
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Josefin Sans",
                          }}
                          variant="text"
                          fontWeight="regular"
                          color="white"
                        >
                          {message.text}
                        </Typography>
                        {/*<div ref={messagesEndRef} />*/}
                      </Box>
                    </Box>
                  </Box>
                )
              })}
            </List>
          </Box>
        </Box>
        <Box px={2} py={1} sx={{ display: "flex", flexDirection: "column" }}>
          <div
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                sendMessage()
              }
            }}
          >
            <TextField
              fullWidth
              multiline={true}
              disabled={loading}
              minRows={4}
              value={newMessage}
              onChange={(event) => {
                setNewMessage(event.target.value)
              }}
            />
          </div>

          <IconButton
            component={Button}
            disabled={loading || !newMessage}
            onClick={() => {
              sendMessage()
            }}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Card>
    </Grid>
  )
}

export default OrderMessages
